// extracted by mini-css-extract-plugin
module.exports = {"productContainer":"ProductList_productContainer__2HJLN"};